export default [
  {
    id: 1,
    price: 600000,
    owner_account_name: "رضا احمدی",
    bank_name: "ملت",
    account_number: "111111111",
    card_number: "2222333344445555",
    shaba: "1234567890",
    status: "در حال بررسی درخواست",
    created_at: "۱۰:۱۵:۰۰ ۱۴۰۱/۰۵/۱۰",
  },
  {
    id: 2,
    price: 1600000,
    owner_account_name: "رضا احمدی",
    bank_name: "صادرات",
    account_number: "9999999",
    card_number: "8888999977776666",
    shaba: "1234567890",
    status: "پرداخت شده",
    paid_at: "۰۹:۱۰:۰۰ ۱۴۰۱/۰۵/۳۱",
    created_at: "۲۰:۵۵:۰۰ ۱۴۰۱/۰۵/۳۰",
  },
  {
    id: 3,
    price: 2000000,
    owner_account_name: "رضا احمدی",
    bank_name: "ملت",
    account_number: "111111111",
    card_number: "2222333344445555",
    shaba: "1234567890",
    status: "رد شده",
    message: "تا انتهای ماه هیچ تسویه حسابی نداریم.",
    created_at: "۱۳:۰۷:۰۰ ۱۴۰۱/۰۶/۲۰",
  },
];
